class EventStore {
    constructor() {
        this.queue = {};
    }

    publish(event, data) {
        let queue = this.queue[event];
        //console.log('Event ' + event + ' was published with this data ' + data)

        if (typeof queue === 'undefined') {
            return false;
        }


        for (var i = 0; i < queue.length; i++) {
            (queue[i])(data);
        }
        /*while (queue.length > 0) {
            (queue.shift())(data);
        }*/

        return true;
    }

    clearAll(){
        this.queue = {};
    }

    subscribe(event, callback) {
        //console.log(event + ' was subscribed')
        if (typeof this.queue[event] === 'undefined') {
            this.queue[event] = [];
        }

        this.queue[event].push(callback);
    }

    //  the callback parameter is optional. Without it the whole event will be removed, instead of
    // just one subscibtion. Enough for simple implementations
    unsubscribe(event, callback) {
        let queue = this.queue;

        if (typeof queue[event] !== 'undefined') {
            if (typeof callback === 'undefined') {
                delete queue[event];
            } else {
                this.queue[event] = queue[event].filter(function(sub) {
                    return sub !== callback;
                })
            }
        }
    }
}

const EventSystem = new EventStore();
Object.freeze(EventSystem);

export default EventSystem;
//module.exports = new EventSystem();

// sourced from https://gist.github.com/simonberger/13d3a416cdf3e72b5a46b031a9fb997d
// updated from https://www.sitepoint.com/javascript-design-patterns-singleton/
